<template>
  <v-container>
    <v-layout wrap>
      <v-layout
        :class="{'column': $vuetify.breakpoint.mdAndDown, 'row': $vuetify.breakpoint.lgAndUp}"
      >
        <v-flex
          xs12
          sm12
          md12
          lg4
          justify-center
        >
          <v-card>
            <v-app-bar
              flat
              color="secondary"
              class="pb-0"
            >
              <h4>Company Details</h4>
            </v-app-bar>
            <v-divider />
            <v-list dense>
              <v-list-item>
                <v-list-item-content>Location</v-list-item-content>
                <v-list-item-content>Intershore Chambers, Road Town, Tortola, VG1110, British Virgin Islands</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Phone | Swiss Number</v-list-item-content>
                <v-list-item-content>+41 225349859</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Copyrights Website Imprint</v-list-item-content>
                <v-list-item-content>
                  <a
                    class="copyrighted-badge"
                    title="Copyrighted.com Registered &amp; Protected"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.copyrighted.com/website/C7M74ZizUcH19Gq9"
                  >
                    <img
                      alt="Copyrighted.com Registered &amp; Protected"
                      border="0"
                      width="125"
                      height="25"
                      srcset="https://static.copyrighted.com/badges/125x25/02_2_2x.png 2x"
                      src="https://static.copyrighted.com/badges/125x25/02_2.png"
                    >
                  </a>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Copyrights Game Imprint</v-list-item-content>
                <v-list-item-content>
                  <a
                    class="copyrighted-badge"
                    title="Copyrighted.com Registered &amp; Protected"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.copyrighted.com/work/gn5TI3TX7YTkusGP"
                  >
                    <img
                      alt="Copyrighted.com Registered &amp; Protected"
                      border="0"
                      width="125"
                      height="25"
                      srcset="https://static.copyrighted.com/badges/125x25/02_2_2x.png 2x"
                      src="https://static.copyrighted.com/badges/125x25/02_2.png"
                    >
                  </a>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          sm12
          md12
          lg8
          justify-center
        >
          <v-card>
            <v-app-bar
              flat
              color="secondary"
              role="heading"
              aria-level="1"
            >
              <v-app-bar-title>Policy</v-app-bar-title>
            </v-app-bar>


            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Introduction
            </v-app-bar>
            <v-card-text>It is RedArc Studio Ltd policy to respect your privacy regarding any information we may collect while operating our website. This Privacy Policy applies to www.animemixedworld.com, *.goz.fun, www.animemixedworld.net, *.goz.fun, www.animemixedworld.net (hereinafter, "us", "we", or "www.animemixedworld.com, *.goz.fun, www.animemixedworld.net"). We respect your privacy and are committed to protecting personally identifiable information you may provide us through the Website. We have adopted this privacy policy ("Privacy Policy") to explain what information may be collected on our Website, how we use this information, and under what circumstances we may disclose the information to third parties. This Privacy Policy applies only to information we collect through the Website and does not apply to our collection of information from other sources.</v-card-text>
            <v-card-text>This Privacy Policy, together with the Terms and conditions posted on our Website, set forth the general rules and policies governing your use of our Website. Depending on your activities when visiting our Website, you may be required to agree to additional terms and conditions.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Website Visitors
            </v-app-bar>
            <v-card-text>Like most website operators, RedArc Studio Ltd collects non-personally-identifying information of the sort that web browsers and servers typically make available, such as the browser type, language preference, referring site, and the date and time of each visitor request. RedArc Studio Ltd’s purpose in collecting non-personally identifying information is to better understand how RedArc Studio Ltd’s visitors use its website. From time to time, RedArc Studio Ltd may release non-personally-identifying information in the aggregate, e.g., by publishing a report on trends in the usage of its website.</v-card-text>
            <v-card-text>RedArc Studio Ltd also collects potentially personally-identifying information like Internet Protocol (IP) addresses for logged in users and for users leaving comments on http://www.animemixedworld.com, *.goz.fun, www.animemixedworld.net blog posts. RedArc Studio Ltd only discloses logged in user and commenter IP addresses under the same circumstances that it uses and discloses personally-identifying information as described below.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Account Deactivation Procedure
            </v-app-bar>
            <v-card-text>
              The deactivation of an account may be initiated by our company or by the user. If initiated by our company, we will provide a clear and detailed explanation of the reason for deactivation.
              If initiated by the user, after deactivation of an account, we may retain certain data associated with it for a certain period of time in accordance with our data retention policies.
              However, users may request the deletion of their data after their account has been deactivated. You may ask us to delete or remove your Personal Data by contacting us at amwgoz@goz.fun. We will respond to your request within a reasonable period of time.
            </v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Account Deactivation
            </v-app-bar>
            <v-card-text>
              The deactivation of an account may be initiated by our company or by the user. If initiated by our company, we will provide a clear and detailed explanation of the reason for deactivation.
              If initiated by the user, after deactivation of an account, we may retain certain data associated with it for a certain period of time in accordance with our data retention policies.
              However, users may request the deletion of their data after their account has been deactivated. You may ask us to delete or remove your Personal Data by contacting us at amwgoz@goz.fun. We will respond to your request within a reasonable period of time.
            </v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Ensure of Data
            </v-app-bar>
            <v-card-text>
              After deactivation of an account, we may retain certain data associated with it for a certain period of time in accordance with our data retention policies.
              However, users may request the deletion of their data after their account has been deactivated. You may ask us to delete or remove your Personal Data by contacting us at amwgoz@goz.fun. We will respond to your request within a reasonable period of time.
            </v-card-text>

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Request Data Deletion
            </v-app-bar>
            <v-card-text>
              Accordingly, you can request modification or deletion of your information. We will take reasonable steps to verify your identity before granting any such request to prevent unauthorized access.
            </v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Account Termination
            </v-app-bar>
            <v-card-text>
              In some cases, user accounts may be terminated without notice, particularly if they violate our terms of service or engage in fraudulent activities. In such cases, users will not be able to access their accounts or retrieve any data associated with them.
            </v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Appeal Process
            </v-app-bar>
            <v-card-text>
              Users who believe that their account was deactivated in error may appeal the decision by contacting our customer support team. We will review the case and provide a response within a reasonable period of time.
            </v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Request of Copy of User Data
            </v-app-bar>
            <v-card-text>We can provide the user a copy of his/her data, after few steps of verifications to make sure that the user is the owner of the data. Unless we're contacted from high authorities, such as court that they requires the data for specific case.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Gathering of Personally-Identifying Information
            </v-app-bar>
            <v-card-text>Certain visitors to RedArc Studio Ltd websites choose to interact with RedArc Studio Ltd in ways that require RedArc Studio Ltd to gather personally-identifying information. The amount and type of information that RedArc Studio Ltd gathers depends on the nature of the interaction. For example, we ask visitors who sign up for a blog at http://www.animemixedworld.com, *.goz.fun, www.animemixedworld.net to provide a username and email address.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Security
            </v-app-bar>
            <v-card-text>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Advertisements
            </v-app-bar>
            <v-card-text>Ads appearing on our website may be delivered to users by advertising partners, who may set cookies. These cookies allow the ad server to recognize your computer each time they send you an online advertisement to compile information about you or others who use your computer. This information allows ad networks to, among other things, deliver targeted advertisements that they believe will be of most interest to you. This Privacy Policy covers the use of cookies by RedArc Studio Ltd and does not cover the use of cookies by any advertisers.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Links To External Sites
            </v-app-bar>
            <v-card-text>Our Service may contain links to external sites that are not operated by us. If you click on a third party link, you will be directed to that third party`s site. We strongly advise you to review the Privacy Policy and terms and conditions of every site you visit.</v-card-text>
            <v-card-text>We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites, products or services.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Protection of Certain Personally-Identifying Information
            </v-app-bar>
            <v-card-text>RedArc Studio Ltd discloses potentially personally-identifying and personally-identifying information only to those of its employees, contractors and affiliated organizations that (i) need to know that information in order to process it on RedArc Studio Ltd behalf or to provide services available at RedArc Studio Ltd’s website, and (ii) that have agreed not to disclose it to others. Some of those employees, contractors and affiliated organizations may be located outside of your home country; by using RedArc Studio Ltd website, you consent to the transfer of such information to them. RedArc Studio Ltd will not rent or sell potentially personally-identifying and personally-identifying information to anyone. Other than to its employees, contractors and affiliated organizations, as described above, RedArc Studio Ltd discloses potentially personally-identifying and personally-identifying information only in response to a subpoena, court order or other governmental request, or when RedArc Studio Ltd believes in good faith that disclosure is reasonably necessary to protect the property or rights of RedArc Studio Ltd, third parties or the public at large.</v-card-text>
            <v-card-text>If you are a registered user of http://www.animemixedworld.com, *.goz.fun, www.animemixedworld.net and have supplied your email address, RedArc Studio Ltd may occasionally send you an email to tell you about new features, solicit your feedback, or just keep you up to date with what’s going on with RedArc Studio Ltd and our products. We primarily use our blog to communicate this type of information, so we expect to keep this type of email to a minimum. If you send us a request (for example via a support email or via one of our feedback mechanisms), we reserve the right to publish it in order to help us clarify or respond to your request or to help us support other users. RedArc Studio Ltd takes all measures reasonably necessary to protect against the unauthorized access, use, alteration or destruction of potentially personally-identifying and personally-identifying information.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Aggregated Statistics
            </v-app-bar>
            <v-card-text>RedArc Studio Ltd may collect statistics about the behavior of visitors to its website. RedArc Studio Ltd may display this information publicly or provide it to others. However, RedArc Studio Ltd does not disclose your personally-identifying information.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Affiliate Disclosure
            </v-app-bar>
            <v-card-text>This site uses affiliate links and does earn a commission from certain links. This does not affect your purchases or the price you may pay.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Cookies
            </v-app-bar>
            <v-card-text>To enrich and perfect your online experience, RedArc Studio Ltd uses "Cookies", similar technologies and services provided by others to display personalized content, appropriate advertising and store your preferences on your computer.</v-card-text>
            <v-card-text>A cookie is a string of information that a website stores on a visitor’s computer, and that the visitor’s browser provides to the website each time the visitor returns. RedArc Studio Ltd uses cookies to help RedArc Studio Ltd identify and track visitors, their usage of http://www.animemixedworld.com, and their website access preferences. RedArc Studio Ltd visitors who do not wish to have cookies placed on their computers should set their browsers to refuse cookies before using RedArc Studio Ltd websites, with the drawback that certain features of RedArc Studio Ltd’s websites may not function properly without the aid of cookies.</v-card-text>
            <v-card-text>By continuing to navigate our website without changing your cookie settings, you hereby acknowledge and agree to RedArc Studio Ltd use of cookies. We use this for solo-purpose to keep user logged if they close the browser, they can easily restrict this by browser.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              E-commerce
            </v-app-bar>
            <v-card-text>Those who engage in transactions with RedArc Studio Ltd – by purchasing RedArc Studio Ltd`s services or products, are asked to provide additional information, including as necessary the personal and financial information required to process those transactions. In each case, RedArc Studio Ltd collects such information only insofar as is necessary or appropriate to fulfill the purpose of the visitor’s interaction with RedArc Studio Ltd. RedArc Studio Ltd does not disclose personally-identifying information other than as described below. And visitors can always refuse to supply personally-identifying information, with the caveat that it may prevent them from engaging in certain website-related activities.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Business Transfers
            </v-app-bar>
            <v-card-text>If RedArc Studio Ltd, or substantially all of its assets, were acquired, or in the unlikely event that RedArc Studio Ltd goes out of business or enters bankruptcy, user information would be one of the assets that is transferred or acquired by a third party. You acknowledge that such transfers may occur, and that any acquirer of RedArc Studio Ltd may continue to use your personal information as set forth in this policy.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              Privacy Policy Changes
            </v-app-bar>
            <v-card-text>Although most changes are likely to be minor, RedArc Studio Ltd may change its Privacy Policy from time to time, and in RedArc Studio Ltd sole discretion. RedArc Studio Ltd encourages visitors to frequently check this page for any changes to its Privacy Policy. Your continued use of this site after any change in this Privacy Policy will constitute your acceptance of such change.</v-card-text>

            <v-divider />

            <v-app-bar
              flat
              color="primary"
              class="font-weight-thin text-uppercase"
              role="heading"
              aria-level="2"
            >
              3rd Parties
            </v-app-bar>
            <v-card-text>A must of 3rd Parties, we must use in order to operate such a large website and maintainability</v-card-text>
            <v-subheader>We use only few, which are the following:</v-subheader>

            <v-list dense>
              <v-list-item>
                <v-list-item-action class="justify-center">
                  <v-icon>fal fa-check</v-icon>
                </v-list-item-action>
                <v-list-item-content>Google Analytics - Used for gathering users what buttons they press the most or links, for us to re-order the website.</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action class="justify-center">
                  <v-icon>fal fa-check</v-icon>
                </v-list-item-action>
                <v-list-item-content>Facebook Media Interaction - Used for like, share, embed post</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action class="justify-center">
                  <v-icon>fal fa-check</v-icon>
                </v-list-item-action>
                <v-list-item-content>Payment Gateways - Used for payments, we usually use pretty strict gateways such as PayPal</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action class="justify-center">
                  <v-icon>fal fa-check</v-icon>
                </v-list-item-action>
                <v-list-item-content>Websites that shared onto our Social Network, we get meta tags such as title, description to show it when someone share a URL</v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider />
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "TcPolicy",
};
</script>
